import { fetchFromObject } from 'helpers/object';

export default {
  getOperationDataField: state => field => fetchFromObject(state, field),

  getDataForOfferStateProcess: (state, getters) => ({
    identityCard: getters.getOperationDataField('prospect.contact.0.documentId'),
    email: getters.getOperationDataField('prospect.contact.0.email')
  }),

  getDataForInstantor: (state, getters) => ({
    firstName: getters.getOperationDataField('prospect.contact.0.name'),
    lastName: `${getters.getOperationDataField(
      'prospect.contact.0.lastname'
    )} ${getters.getOperationDataField('prospect.contact.0.lastname2')}`,
    email: getters.getOperationDataField('prospect.contact.0.email')
  })
};
